<template>
    <div class="ra-section">
        <div class="ra-section__inner" :class="{visible : hasEntries}">
            <print-config-layout>
                <template #icon>
                    <component :is="iconComponent" />
                </template>
                <template #text>
                    <h2>{{config.title}}</h2>
                </template>
            </print-config-layout>
            <print-config-level
                    v-for="(item,index) in config.children"
                    :config="item"
                    :answers="answers.children[index]"
                    :questionIcon="questionIcons[index]"
                    :level="1"
            />
        </div>
    </div>
</template>

<script>
    import printConfigLevel from "@components/pages/print/concrete/print-config-level";
    import {questions} from "@constants/common";
    import printConfigLayout from "@pages/print/concrete/print-config-layout"

    export default {
        name: "print-config-section",
        components: {
            printConfigLayout,
            printConfigLevel
        },
        props: {
            config: {
                type: Object
            },
            answers: {
                type: Object
            },
            sectionIcon: {
                type: String
            },
            questionIcons: {
                type: Array
            }
        },
        data() {
            return {
                hasEntries: null
            }
        },
        computed: {
            iconComponent() {
                return this.sectionIcon;
            }
        },
        methods: {
            checkIfExistsEntries(config, answers) {
                for (let i = 0; i < answers.length; i++) {
                    if (config[i].type === questions.types.notice && answers[i].answer) {
                        this.hasEntries = true;
                    } else if (answers[i].type === questions.types.evaluation) {
                        this.hasEntries = true;
                    } else if (answers[i].answer && answers[i].children) {
                        this.checkIfExistsEntries(config[i].children, answers[i].children)
                    }
                }
            }
        },
        created() {
            this.checkIfExistsEntries(this.config.children, this.answers.children)
        }
    }
</script>

<style lang="scss">
    .print-risk-assessment__ra-section {
        .ra-section__inner {
            display: none;
            padding: 1.5rem;
            border: solid 2px var(--v-secondary-darken1);
            margin-bottom: 50px;

            &.visible {
                display: block;
            }
        }
    }
</style>